import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { Shirt } from "../../entities/Shirt";
import { useContext, useEffect, useState } from "react";
import DefaultShirt from "../../img/defaultShirt.png";
import FormatService from "../../services/formatService";
import DeleteIcon from "@mui/icons-material/Delete";
import CurrentValue from "../Top10ElementShirt/CurrentValue";
import DialogService from "../Dialog/dialogService";
import ShirtDetail from "../ShirtDetail/ShirtDetail";
import { AbilityContext } from "../../permission/Can";
import LegitCheckService from "../../services/legitCheckService";
import LegitCheckResults from "../LegitCheckResults/LegitCheckResults";
import { LegitCheckItem } from "../../types/types";
import { Actions, Subjects } from "../../permission/constants";

interface Top10ElementMobileProps {
  shirt: Shirt;
  position: number;
  remove?: Function;
  userName: string;
}

const Top10ElementMobile = ({
  shirt,
  position,
  remove,
  userName,
}: Top10ElementMobileProps) => {
  const [image, setImage] = useState<string>(DefaultShirt);
  const [lcResults, setLcResults] = useState<Array<LegitCheckItem> | undefined>(
    undefined
  );
  const [positiveChecks, setPositiveChecks] = useState<number | undefined>(
    undefined
  );

  const ability = useContext(AbilityContext);
  const { openMD } = DialogService();
  const { getPlayerName } = FormatService();
  const { getLegitChecks } = LegitCheckService();

  const cardSize = 270;

  const shirtDetails = () => {
    openMD(userName, <ShirtDetail shirt={shirt} />, []);
  };

  const removeItem = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (remove) {
      remove(position);
    }
  };
  const legitCheckResults = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (shirt?.id) {
      openMD(
        "Legit Check Results",
        <LegitCheckResults itemId={shirt.id} legitChecks={lcResults} />,
        []
      );
    }
  };

  useEffect(() => {
    if (shirt.images[0]) {
      setImage(shirt.images[0].url);
    }
    if (shirt?.id && ability.can(Actions.VIEW, Subjects.LEGIT_CHECK)) {
      getLegitChecks(shirt.id).then((results) => {
        if (results) {
          const isLegitResults = results.filter((item) => item.is_legit).length;
          setLcResults(results);
          setPositiveChecks(isLegitResults);
        }
      });
    }
  }, [shirt]);

  return (
    <Card sx={{ width: "100%", borderRadius: "10px", padding: "1rem" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0.5rem 0rem",
        }}
      >
        <Avatar
          component={Paper}
          elevation={2}
          sx={{
            backgroundColor: "white",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#3c3c40",
              fontWeight: "700",
              fontSize: "1.75rem !important",
              fontFamily: "Manrope",
            }}
          >
            {position}
          </Typography>
        </Avatar>
        <Box>
          <Typography
            gutterBottom
            variant="body2"
            sx={{
              color: "#3c3c40",
              fontWeight: "700",
              fontSize: "1rem !important",
              marginBottom: "4px !important",
            }}
          >
            {shirt.model.team.name} - {shirt.model.season.start_year}/
            {shirt.model.season.end_year}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#6f7d95",
              fontWeight: "400",
              fontSize: "1rem !important",
            }}
          >
            {shirt.model.player
              ? shirt.model.player.alias &&
                shirt.model.player.name !== shirt.model.player.alias
                ? `${shirt.model.player.name} "${shirt.model.player.alias}"`
                : shirt.model.player.name
              : ""}
          </Typography>
          {ability.can(Actions.VIEW, Subjects.LEGIT_CHECK) && (
            <Button
              sx={{
                zIndex: 10,
                color: "#6f7d95",
                fontWeight: "600",
                fontSize: "0.8rem !important",
                padding: "0px 2px",
                justifyContent: "flex-start",
                textDecoration: "underline",
              }}
              onClick={legitCheckResults}
            >
              LC ({positiveChecks ? positiveChecks : "0"}/
              {lcResults ? lcResults.length : "0"})
            </Button>
          )}
        </Box>
        <Box>
          {remove ? (
            <IconButton
              onClick={removeItem}
              sx={{
                color: "#bfbfbf",
                float: "right",
                fontSize: "30px !important",
              }}
            >
              <DeleteIcon
                sx={{
                  fontSize: "25px !important",
                  color: "red !important",
                }}
              />
            </IconButton>
          ) : (
            <></>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#ffffff",
        }}
        onClick={shirtDetails}
      >
        <CardMedia
          component="img"
          image={image}
          alt={shirt.title}
          style={{
            objectFit: "cover",
            objectPosition: "50% 50%",
            borderRadius: "10px",
          }}
        />
      </Box>

      <Box
        sx={{
          width: "100%",
          marginTop: "10px",
        }}
      >
        <CurrentValue value={Number(shirt.current_price)} />
      </Box>
    </Card>
  );
};

export default Top10ElementMobile;
